module.exports = __webpack_public_path__ + "static/img/img_yewu4.9778639.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/web_img/img_yewu4.png
// module id = Q3um
// module chunks = 1